import React, { Fragment, useState, useEffect } from "react"
import ReactDOM from "react-dom"
import { Box, List, ListItem, Typography, Link } from "@material-ui/core"
import Button from "../../CustomButtons/Button"
import { makeStyles } from "@material-ui/core/styles"
import { Avatar } from "@material-ui/core"
import NewsImage from "../../../assets/images/new-list-img.png"
import NewsItem from "./NewsItem"
import * as actionContents from "../../../store/actions/contentActions"
import { useDispatch, useSelector } from "react-redux"

const useStyles = makeStyles(theme => ({
  ullist: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))
const NewsList = () => {
  const dispatch = useDispatch()
  const { newsItems, eventsItems } = useSelector(state => ({
    newsItems: state.content.newsData,
    eventsItems: state.content.eventsData,
  }))
  // const [newsItems, SetNewsItems] = useState([])
  ///
  useEffect(() => {
    //dispatch(actionContents.fetchDataFromHBKU("news"))
    dispatch(actionContents.fetchXMLHttpRequest("news"))
    //  dispatch(actionContents.fetchXMLHttpRequest("events"))
  }, [])

  const classes = useStyles()
  return (
    <Fragment>
      <Box component="div" className="mez news-content news--list mez-pointer">
        <Box component="div" className="mez sorter"></Box>
        <Box component="div" className="news__block">
          <List className={classes.ullist}>
            {newsItems &&
              newsItems.map((news, index) => (
                <NewsItem data={news} key={index} />
              ))}
          </List>
        </Box>
      </Box>
    </Fragment>
  )
}

export default NewsList
